const GameFlowEvent = {};
export default GameFlowEvent;

GameFlowEvent.TUTORIAL_COMPLETED = "GameFlowEvent.INTRO_COMPLETED";
GameFlowEvent.TRANSITION_TO_DIALOG = "GameFlowEvent.TRANSITION_TO_DIALOG";